import type { IconsGrid } from '@ps/web-martech-cms-types';
import React from 'react';

import IconsGridItems from './IconsGridItems';

type Props = IconsGrid & { wrapperClassName?: string };

const CMSIconsGrid: React.FC<Props> = ({ wrapperClassName, ...iconsGrid }) => {
  if (!iconsGrid.group_items) return null;

  return (
    <>
      {iconsGrid.group_items.map(({ items, visibility_rules: visibilityRules }, groupIndex) => (
        <IconsGridItems
          key={groupIndex}
          {...iconsGrid}
          items={items}
          visibilityRules={visibilityRules}
          wrapperClassName={wrapperClassName}
        />
      ))}
    </>
  );
};

export default CMSIconsGrid;
